import React, { Fragment } from "react";
import PreList from "./PrescreeningList";

class PrescreeningList extends React.Component {
  render() {
    return (
      <Fragment>
        <PreList redirect={this.props} permissions={["ADMIN", "SUPER_ADMIN"]} />
      </Fragment>
    );
  }
}

export default PrescreeningList;
